import axios from "../lib/axios";

// Create a new event
export const createEvent = async (payload) => {
  try {
    const response = await axios.post("/events", payload);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to create event");
  }
};

// Update event details
export const updateEvent = async (id, payload) => {
  try {
    const response = await axios.put(`/events/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to update event");
  }
};

// Delete event (using unified route)
export const deleteEvent = async (id) => {
  try {
    const response = await axios.delete(`/events/${id}?action=delete`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to delete event");
  }
};

// Update event status (active/inactive)
export const updateEventStatus = async (id, status) => {
  try {
    const response = await axios.patch(`/events/${id}?action=status`, {
      status,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update status"
    );
  }
};

// Update event approval status (pending/approved/rejected)
export const updateEventApproval = async (id, approvalStatus) => {
  try {
    const response = await axios.patch(`/events/${id}?action=approval`, {
      approvalStatus,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update approval status"
    );
  }
};

export const getAllEvents = async ({
  page = 1,
  limit = 9,
  status,
  approvalStatus,
  homepage = false,
  category,
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("limit", limit.toString());
    if (status) params.append("status", status);
    if (approvalStatus) params.append("approvalStatus", approvalStatus);
    if (homepage) params.append("homepage", homepage.toString());
    if (category) params.append("category", category);

    const response = await axios.get(`/events/all?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to fetch events");
  }
};

// Get single event by ID
export const getEventById = async (id) => {
  try {
    const response = await axios.get(`/events/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to fetch event");
  }
};

// Create payment order
export const createPaymentOrderAqua2026 = async (payload) => {
  try {
    const response = await axios.post(
      "/event-register-aqua-2026/create-order",
      payload
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create payment order"
    );
  }
};

// Verify payment
export const verifyPaymentAqua2026 = async (payload) => {
  try {
    const response = await axios.post(
      "/event-register-aqua-2026/verify-payment",
      payload
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Payment verification failed"
    );
  }
};

export async function fetchRegistrations({ page = 1, limit = 10 }) {
  try {
    const response = await axios.get("/event-register-aqua-2026", {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      (error.response && error.response.data && error.response.data.message) ||
        "Failed to fetch registrations"
    );
  }
}

export const deleteEventAqua = async (id) => {
  try {
    const response = await axios.delete(`/event-register-aqua-2026/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to delete event");
  }
};
